import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAdditionalClasses } from "../assets/js/utils";
import { scroller } from "react-scroll";
import {
  addAllSections,
  changeSection,
  logoClicked,
  toggleSectionContentDisplay,
} from "../store/auxiliary/ui/sections";
import ContentArea from "./ContentArea";
import useSectionsHandler from "./hooks/useSectionsHandler";
import Navbar from "./Navbar";
import generalSettings, {
  toggleLogoClicked,
} from "../store/auxiliary/ui/generalSettings";
import { getSections } from "../assets/content/content";

function MainContainer(props) {
  const sections = useSelector((state) => state.ui.sections);
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(addAllSections(getSections()));
  }, []);

  const handleLogoClick = () => {
    // if (sections.displayContent) {
    //   dispatch(changeSection(0));
    //   dispatch(toggleSectionContentDisplay(false));
    // } else {
    //   if (sections.currentSection !== 0) {
    //     scroller.scrollTo(`scroll-section-${0}`, {
    //       duration: 700,
    //       ignoreCancelEvents: true,
    //       // delay: 100,
    //       smooth: "easeInCubic",
    //       containerId: "content-area__wrapper",
    //       // offset: 50,
    //     });
    //     dispatch(changeSection(0));
    //   }
    // }

    if (sections.displayContent) {
      dispatch(toggleSectionContentDisplay(false));
    }
    dispatch(toggleLogoClicked());
    dispatch(changeSection(0));
  };
  // useSectionsHandler();

  return (
    <div
      className={`main-container${setAdditionalClasses(
        ["animation-hide-show-main-container"],
        [sections.readMorePressed || sections.readMoreClosed]
      )}`}
    >
      <Navbar handleLogoClick={handleLogoClick} />
      <ContentArea key={generalSettings.logoClicked ? 1 : 0} />
      {/* {!sections.displayContent && <ContentArea />}
      {sections.displayContent && (
        <div style={{ height: "100vh", backgroundColor: "yellow" }}>
          <p>display content</p>
          <button
            style={{ margin: "auto" }}
            onClick={() => dispatch(toggleSectionContentDisplay(false))}
          >
            Close
          </button>
        </div>
      )} */}
    </div>
  );
}

export default MainContainer;
